import axios from 'axios';
import { axiosETAGCache } from 'axios-etag-cache';

let globalIntegrationSchema = null;

// Apply the axios ETAG interceptor
const axiosWithETAGCache = axiosETAGCache(axios);
const api = {
  async getIntegrationsSchema() {
    if (globalIntegrationSchema) {
      return globalIntegrationSchema;
    }
    const response = await axiosWithETAGCache.get(`/integrations/schema`);
    globalIntegrationSchema = response.data;
    return response.data;
  },
  async getIntegrations() {
    const queryParams = {};

    const response = await axiosWithETAGCache.get(`/integrations`, {
      params: queryParams,
    });

    return response.data;
  },
  async getIntegration(providerConfigKey) {
    const queryParams = {};

    const response = await axiosWithETAGCache.get(
      `/integrations/${providerConfigKey}`,
      {
        params: queryParams,
      }
    );

    return response.data;
  },
  async startIntegrationAuthorization(integration_unique_key, credentials = null) {
    const response = await axiosWithETAGCache.post(
      `/integrations/${integration_unique_key}/authorization`,
      credentials || {},  // Ensure we always send an object
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  },
  async startSynchronization(providerConfigKey, syncName) {
    const response = await axiosWithETAGCache.post(
      `/integrations/${providerConfigKey}/start/${syncName}`
    );
    return response.data;
  },
  async stopSynchronization(providerConfigKey, syncName) {
    const response = await axiosWithETAGCache.post(
      `/integrations/${providerConfigKey}/stop/${syncName}`
    );
    return response.data;
  },
  async triggerResynchronization(providerConfigKey, syncName) {
    const response = await axiosWithETAGCache.post(
      `/integrations/${providerConfigKey}/trigger/${syncName}`
    );
    return response.data;
  },
  async changeIntegrationSettings(providerConfigKey, settings) {
    const response = await axiosWithETAGCache.patch(
      `/integrations/${providerConfigKey}/settings`,
      settings
    );
    return response.data;
  },
  async deleteIntegration(providerConfigKey) {
    const response = await axiosWithETAGCache.delete(
      `/integrations/${providerConfigKey}`
    );
    return response.data;
  },
      async getRealplusResourceListings() {
        const response = await axiosWithETAGCache.get(
          `/integrations/realplus_resource/listings`
        );
        return response.data;
      },
      async syncRealplusResourceListings() {
        const response = await axiosWithETAGCache.post(
          `/realplus_resource/sync_listings`
        );
        return response.data;
      },
};

export default api;
